import { createStage } from './create'
import { deleteStage } from './delete'
import { readStageById } from './read'
import { resourceObject } from './resourceObject'
import { updateStage } from './update'

export const stages = {
  create: createStage,
  readSingle: readStageById,
  resourceObject,
  update: updateStage,
  delete: deleteStage,
}
